import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { MainService } from 'src/app/services/main/main.service';
import { SocketsService } from 'src/app/services/shared/socket.service';

@Component({
  selector: 'app-bg-proposal-progress',
  templateUrl: './bg-proposal-progress.component.html',
  styleUrls: ['./bg-proposal-progress.component.scss']
})
export class BgProposalProgressComponent implements OnInit {
  @Input() dataFromParentElement: any;
  @Output() data_from_bg_proposal = new EventEmitter();
  number_of_record_processed = 0;
  multiCustomerData: any;
  is_from_raw_file = 0;
  total_number_of_record_processed = 0;
  pie_chart_width_value = { 'background': 'conic-gradient(#2196f3 0% 0%,#cbe3f8  0% 100% )' };
  previous_proposal_count: any;
  processed_percentage: number = 0;
  constructor(public _socket: SocketsService, public mainService: MainService) { }

  ngOnInit() {
    this.check_is_data_processing_background()

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataFromParentElement'] && changes['dataFromParentElement'].currentValue) {
      console.log(changes, "changeschangeschangeschanges")
      this.is_proposal_running_in_background()
    }
  }
  set_values_for_background_processing_data(data) {
    this.number_of_record_processed = data.processed_record_count || 0;
    this.total_number_of_record_processed = data.total_records || 0;
    if (data.is_all_record_processed == 1) {
      this.number_of_record_processed = 0;
    }
    this.processed_percentage = parseFloat(((this.number_of_record_processed / this.total_number_of_record_processed) * 100).toFixed());
    this.pie_chart_width_value = { 'background': `conic-gradient(#2196f3 0% ${this.processed_percentage}%,#cbe3f8  ${this.processed_percentage}% 100% )` };
  }
  check_is_data_processing_background() {
    this._socket.socket.on('proposal_sent', (data) => {
      console.log(data, "datadatadatadata")
        this.set_values_for_background_processing_data(data)
        this.data_from_bg_proposal.next(data)
    })
  }
  is_proposal_running_in_background() {
    let data = {
      access_token: localStorage.getItem('token'),
      doctor_id: this.dataFromParentElement.doctor_id,
    };
    console.log("is_proposal_running_in_backgroundis_proposal_running_in_background")
    this.mainService.api(data, `is_proposal_processing_bg`, true).subscribe(response => {
      if (response.is_error == 0) {
        this.set_values_for_background_processing_data(response)
        this.data_from_bg_proposal.next(response)
      }
    })

  }
}
